module.exports = __webpack_public_path__ + "img/botella_black_1.e2c394a8.jpeg";